<div class="d-flex table-header-border bg-white" style="padding: 24px 32px;"
     *ngIf="innerWidth > mobileViewPortSize && (dropdowns?.length || searchBox)">
  <div *ngIf="searchBox" class="search-container justify-content-start">
    <beaconstac-search (textChange)="searchTextChange($event)" [width]="searchBoxWidth" [searchPlaceholder]="searchPlaceHolder" ></beaconstac-search>
  </div>
  <div class="filter-container justify-content-end">
    <div class="dropdown-container" *ngFor="let dropdown of dropdowns; index as indexOfDropdown">
      <beaconstac-filter-dropdown
        [title]="dropdown['label']['name']"
        [width]="'300px'"
        [value]="dropdown['label']"
        [listItems]="dropdown['list']"
        specificOutput=""
        optionLabelField="name"
        optionValueField="value"
        [disabled]="false"
        (valueChange)="onDropdownValueChange.emit($event)"
        (inputChangeEvent) = "onDropdownSearchInputChange($event, indexOfDropdown)"
        [enableInfiniteScrolling]="enableInfiniteScrolling"
        (fetchMoreData)="fetchDataOnScroll($event)"
        [isFetchingData]="isFetchingData"
      ></beaconstac-filter-dropdown>
    </div>
  </div>
</div>
<div *ngIf="innerWidth < mobileViewPortSize">
  <div class="mobile-table-header">
    <div class="d-flex justify-content-between">
      <div class="search-container">
        <beaconstac-search *ngIf="searchBox" (textChange)="onSearchBoxChange.emit($event)"></beaconstac-search>
      </div>
      <div *ngIf="dropdowns?.length">
        <i class="fas fa-filter" aria-hidden="true" style="font-size: 1.25rem; margin-top: 10px; cursor: pointer;" (click)="toggleDropdowns($event)"></i>
      </div>
    </div>
  </div>
  <div id="accordian" class="accordion">
    <div *ngFor="let dropdown of dropdowns">
      <div class="mobile-dropdown-container">
        <beaconstac-filter-dropdown
          [title]="dropdown['label']"
          [listItems]="dropdown['list']"
          [width]="'248px'"
          optionLabelField="name"
          optionValueField="value"
          [value]="dropdown['label']"
          (valueChange)="onDropdownValueChange.emit($event)"
          [enableInfiniteScrolling]="enableInfiniteScrolling"
          (fetchMoreData)="fetchDataOnScroll($event)"
          [isFetchingData]="isFetchingData"
        ></beaconstac-filter-dropdown>
      </div>
    </div>
  </div>
</div>
<table class="table">
  <thead>
  <tr>
    <th scope="col" *ngIf="showCheckbox" style="max-width: 80px; padding-top: 20px;">
      <beaconstac-checkbox
        [disabled]="tableData['allSelectCheckbox']['disabled']"
        [checked]="tableData['allSelectCheckbox']['checked']"
        [label]="''"
        (checkedChange)="allCheckboxStateEmitter.emit({value: $event, dataObjects: tableData['data']})"
      ></beaconstac-checkbox>
    </th>
    <ng-container *ngIf="innerWidth > mobileViewPortSize">
      <th scope="col" class="header-row" *ngFor="let headerItem of tableData['header'] | keyvalue: originalOrder;">
          <ng-container *ngIf="headerItem['value']['text'] !== 'preview'">
            {{headerItem['value']['text']}}
            <i [ngClass]="(sortColumn !== headerItem['value']['text']) ? 'fa-sort' : (!ascending) ? 'fa-sort-up bstac-tint-blue' : 'fa-sort-down bstac-tint-blue'"
              class="sort-icon fas fa-fw" *ngIf="headerItem['value']['sort']" (click)="handleSortIcon(0, headerItem['value']['text']); sortColumnChange.emit(headerItem['value']['text']); onSort.emit($event);"></i>
          </ng-container>
      </th>
    </ng-container>
    <ng-container *ngIf="innerWidth < mobileViewPortSize">
      <ng-container *ngFor="let headerItem of tableData['header'] | keyvalue: originalOrder;">
        <ng-container *ngIf="headerItem['value']['mobile']">
          <th scope="col" class="header-row" >
              {{headerItem['value']['text']}}
              <i [ngClass]="(sortBy != 0) ? 'fa-caret-down': (!isAscending)?'fa-caret-down bstac-tint-blue': 'fa-caret-down bstac-tint-blue'"
                 class="fas fa-caret-down" *ngIf="headerItem['value']['sort']" (click)="sortColumnChange.emit(headerItem['value']['text']); onSort.emit($event);"></i>
          </th>
        </ng-container>
      </ng-container>
    </ng-container>
    <th *ngIf="showToolBar">
    </th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let listItem of tableData['data']; let i = index;" [ngClass]="listItem['editDisabled'] ? 'edit-disabled' : ''" [ngStyle]="listItem['threatActive'] ? {background: '#FFEFEF'} : {}" (mouseenter)="checkRowHover(i, true)" (mouseleave)="checkRowHover(i, false)">
    <td *ngIf="showCheckbox" style="width: 20px; padding-top: 20px;">
      <beaconstac-checkbox
        [disabled]="listItem['checkboxItem']?.disabled || false"
        [checked]="listItem['checkboxItem']?.checked || false"
        [label]="''"
        (checkedChange)="checkboxStateEmitter.emit({value: $event, dataObject: listItem['dataObject']})"
      ></beaconstac-checkbox>
    </td>
    <td *ngIf="showChartLegendColor" style="width: 20px;">
      <span class="m-1 border-radius-2"
            [ngStyle]="{ 'background-color' : listItem['chartLegendColor'], 'border-radius': '2px' } ">&nbsp;&nbsp;&nbsp;&nbsp;</span>
    </td>
    <td class="image-container" style="text-align: center"
        *ngIf="listItem['preview'] && innerWidth > mobileViewPortSize">
      <div class="tooltip" style="width: 20px;">
        <img height="100" [ngStyle]="circularProfileImage ? customImageStyles: {} " [src]="listItem['preview']" alt="" [ngClass]="{'img-container-dark': qrHasLowScannability(listItem)}">
        <div class="tooltip-content" [ngClass]="{'img-container-dark': qrHasLowScannability(listItem)}">
          <span><img height="100" [ngStyle]="circularProfileImage ? {'border-radius':'50%'}: {} " [src]="listItem['preview']" alt=""></span>
          <i class="caret caret-center"></i>
        </div>
      </div>
    </td>

    <ng-container *ngIf="innerWidth > mobileViewPortSize">
      <td class="data" *ngFor="let dataItem of listItem['dataItems'] | keyvalue: originalOrder; let i = index" [ngClass]="listItem['state'] === 'inactive' ? 'state-inactive' : dataItem['value']['class']" (click)="onRowClick.emit(listItem['dataObject'])"
      [ngStyle]="{'min-width': dataItem['value']['showAddButtonOnHover']?'136px' : ''}">
        <ng-container *ngIf="dataItem['value']['image_data']">
          <div class="tooltip">
            <ng-container *ngIf="dataItem['value']['image_data']['image_url']; else noImageBlock">
              <img
                [src]="dataItem['value']['image_data']['image_url']"
                [alt]="dataItem['value']['image_data']['tooltip_text']" class="image" />
                <div *ngIf="dataItem['value']['image_data']['tooltip_text']" class="tooltip-content image-tooltip image-tooltip-transform">
                  <span>{{dataItem['value']['image_data']['tooltip_text']}}</span>
                  <i class="caret-center image-tooltip-caret"></i>
                </div>
            </ng-container>
            <ng-template #noImageBlock>
              <div class="image rounded-name d-flex align-items-center justify-content-center">
                <ng-container *ngIf="dataItem['value']['image_data']['text']">
                  {{dataItem['value']['image_data']['text']}}
                </ng-container>
                <div *ngIf="dataItem['value']['image_data']['tooltip_text']" class="tooltip-content image-tooltip text-tooltip-transform">
                  <span>{{dataItem['value']['image_data']['tooltip_text']}}</span>
                  <i class="caret-center name-tooltip-caret"></i>
                </div>
              </div>
            </ng-template>
          </div>
        </ng-container>
        <ng-container *ngIf="hasMultipleValues(dataItem['value']['type'])">
          <ng-container *ngIf="truncateLabels; else nonTruncatedLabelBlock">
            <div class="d-inline-flex m-1">
              <beaconstac-tag
                *ngIf="dataItem['value']['values'] && dataItem['value']['values'][0]"
                tagTitle="{{dataItem['value']['values'][0]['text']}}"
                bgColor="{{dataItem['value']['values'][0]['background']}}"
                textColor="{{dataItem['value']['values'][0]['textColor']}}"
                [tooltipEnabled]="dataItem['value']['values'][0]['tooltipEnabled'] || false"
                [tooltipContent]="dataItem['value']['values'][0]['tooltipContent'] || ''">
              </beaconstac-tag>
              <span *ngIf="dataItem['value']['values'].length > 1" (click)="handleClickOnMoreLabels($event, listItem)" class="truncated-labels ml-2">
                +{{(dataItem['value']['values'].length - 1)}} more
              </span>
            </div>
          </ng-container>
          <ng-template #nonTruncatedLabelBlock>
            <ng-container *ngFor="let item of dataItem['value']['values'] | keyvalue: originalOrder">
              <ng-container *ngIf="item['value']['textColor'] && item['value']['background']">
                <div class="m-1 d-inline-flex" (click)="handleOnCellClick(dataItem, listItem['dataObject'])">
                  <beaconstac-tag
                    tagTitle="{{item['value']['text']}}"
                    bgColor="{{item['value']['background']}}"
                    textColor="{{item['value']['textColor']}}"
                    [tooltipEnabled]="item['value']['tooltipEnabled'] || false"
                    [tooltipContent]="item['value']['tooltipContent'] || ''"
                  ></beaconstac-tag>
                </div>
              </ng-container>
                <span *ngIf="!item['value']['textColor'] && !item['value']['background']" (click)="handleOnCellClick(dataItem, listItem['dataObject'])">
                  {{item['value']['text']}}
                </span>
            </ng-container>
          </ng-template>
          <ng-container *ngIf="dataItem['value']['showAddButtonOnHover'] && !dataItem['value']['values']?.length">
            <div [ngClass]="'show-on-hover'" (click)="handleOnCellClick(dataItem, listItem['dataObject'])">
              <i class="fas fa-tag"></i>
              {{dataItem['value']['buttonText']}}
            </div>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="hasSingleValue(dataItem['value']['type']) && !dataItem['value']['image_data']">
          <span class="d-flex align-items-center justify-content-between"
                [attr.title]="dataItem['value']['value']['tooltip_text'] ? null : dataItem['value']['value']['text']"
                [ngStyle]="{'color': dataItem['value']['value']['textColor'], 'background': dataItem['value']['value']['background']}"
                (click)="handleOnCellClick(dataItem, listItem['dataObject'])">
            <span class = "d-inline-block text-truncate" style = "max-width: 168px" *ngIf="!dataItem['value']['clickable'] && dataItem['value']['contentType'] !== 'icon'">
              <span *ngIf="dataItem['value']['value']['tooltip_text']; else noTooltip" class="tooltip text-truncate">
                <span class="tooltip-content text-tooltip tooltip-layout">
                   <span [innerHTML]="dataItem['value']['value']['tooltip_text']"></span>
                  <i class="caret-center name-tooltip-caret"></i>
                </span>
                {{dataItem['value']['value']['text']}}
              </span>

              <ng-template #noTooltip>
                <span>
                  {{dataItem['value']['value']['text']}}
                </span>
              </ng-template>
            </span>
            <span class = "d-inline-block text-truncate" style = "max-width: 168px" *ngIf="dataItem['value']['clickable'] && dataItem['value']['contentType'] !== 'icon'" [ngClass]="{'btn-link cursor-pointer': isLinkPrimary, 'secondary-link': !isLinkPrimary }" (click)="onLinkClick.emit(listItem['dataObject']); $event.stopPropagation()">
              <ng-container *ngIf="dataItem['value']['value']['is_strike']; else noStrike">
                <s>{{ dataItem['value']['value']['text'] }}</s>
              </ng-container>
              <ng-template #noStrike>
                {{ dataItem['value']['value']['text'] }}
              </ng-template>
            </span>
            <span *ngIf="!dataItem['value']['clickable'] && dataItem['value']['contentType'] === 'icon'">
              <i class="{{dataItem['value']['value']['class']}}" aria-hidden="true" [ngStyle]="{'font-size': '20px', 'color': dataItem['value']['value']['color']}"></i>
            </span>
            <span *ngIf="dataItem['value']['contentType'] === 'text/icon'">
              <span class="ml-2 d-flex justify-content-center align-items-center" style="border-radius: 50%; background-color: {{dataItem['value']['iconBackColor']}}; width: 32px; height: 32px;">
                  <beaconstac-tooltip
                    *ngIf="dataItem['value']['tooltipContent']"
                    [elementClass]="dataItem['value']['iconClass']"
                    content="{{dataItem['value']['tooltipContent']}}"
                    [color]="dataItem['value']['tooltipColor']"
                  ></beaconstac-tooltip>
                </span>
            </span>
          </span>
        </ng-container>
        <ng-container *ngIf="isProgressBar(dataItem['value']['type']); let barType">
          <div class="progress-bar-wrapper">
            <div
              class="progress-bar"
              [ngStyle]="{'background-color': dataItem['value']['value']['color']}"
              [style.width.%]="(dataItem['value']['value']['width'] / dataItem['value']['maxWidth']) * 100">
            </div>
            <span class="percentage-label">{{ dataItem['value']['value']['text'] }}</span>
          </div>
        </ng-container>

        <ng-container *ngIf="isTrendType(dataItem['value']['type']); let trendType">
          <ng-container *ngIf="dataItem['value']['value'] as trendValue">
            <div
              class="percentage-box"
              [attr.title]="dataItem['value']['value']['tooltip_text'] ? null : dataItem['value']['value']['text']"
              [ngClass]="{
                'dark-grey': trendValue.empty,
                'badge-red': !trendValue.empty && trendValue.negative,
                'badge-green': !trendValue.empty && !trendValue.negative
              }">

              <span class = "d-inline-block text-truncate" style = "max-width: 168px">
              <span *ngIf="dataItem['value']['value']['tooltip_text']; else noTooltip" class="tooltip text-truncate">
                <span class="tooltip-content text-tooltip tooltip-layout">
                   <span [innerHTML]="dataItem['value']['value']['tooltip_text']"></span>
                  <i class="caret-center name-tooltip-caret"></i>
                </span>
                <div>
                  <i *ngIf="trendValue && !trendValue.empty"
                     style="margin-right: 4px"
                     [class]="!trendValue.negative ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"
                  ></i>
                  <span class="scan-text">{{ trendValue.text }}</span>
                </div>

              </span>

              <ng-template #noTooltip>
                <div>
                  <i *ngIf="trendValue && !trendValue.empty"
                     style="margin-right: 4px"
                     [class]="!trendValue.negative ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"
                  ></i>
                  <span class="scan-text">{{ trendValue.text }}</span>
                </div>

              </ng-template>
            </span>
            </div>
          </ng-container>
        </ng-container>
      </td>
    </ng-container>
    <ng-container *ngIf="innerWidth < mobileViewPortSize">
      <ng-container *ngFor="let dataItem of listItem['dataItems'] | keyvalue: originalOrder;">
        <ng-container *ngIf="dataItem['value']['mobile']">
          <td class="data" [ngClass]="listItem['state'] === 'inactive' ? 'state-inactive' : dataItem['value']['class']" (click)="onRowClick.emit(listItem['dataObject'])">
            <ng-container *ngIf="dataItem['value']['mobile']">
            <span class="d-flex align-items-center justify-content-between"  title = "{{dataItem['value']['value']['text']}}" style="color: {{dataItem['value']['value']['textColor']}}; background: {{dataItem['value']['value']['background']}}" (click)="handleOnCellClick(dataItem, listItem['dataObject'])">
              <span class = "d-inline-block text-truncate" style = "max-width: 168px" *ngIf="!dataItem['value']['clickable'] && dataItem['value']['contentType'] !== 'icon'">
                {{dataItem['value']['value']['text']}}
              </span>
              <span class = "d-inline-block text-truncate" style = "max-width: 168px" *ngIf="dataItem['value']['clickable'] && dataItem['value']['contentType'] !== 'icon'" [ngClass]="{'btn-link cursor-pointer': isLinkPrimary, 'secondary-link': !isLinkPrimary }" (click)="onLinkClick.emit(listItem['dataObject']); $event.stopPropagation()">
                {{dataItem['value']['value']['text']}}
              </span>
              <span *ngIf="!dataItem['value']['clickable'] && dataItem['value']['contentType'] === 'icon'">
                <i class="{{dataItem['value']['value']['class']}}" aria-hidden="true" style="font-size: 20px; color: {{dataItem['value']['value']['color']}}"></i>
              </span>
              <span *ngIf="dataItem['value']['contentType'] === 'text/icon'">
                <span class="ml-2 d-flex justify-content-center align-items-center" style="border-radius: 50%; background-color: {{dataItem['value']['iconBackColor']}}; width: 32px; height: 32px;">
                    <beaconstac-tooltip
                      *ngIf="dataItem['value']['tooltipContent']"
                      [elementClass]="dataItem['value']['iconClass']"
                      content="{{dataItem['value']['tooltipContent']}}"
                      [color]="dataItem['value']['tooltipColor']"
                    ></beaconstac-tooltip>
                  </span>
              </span>
            </span>
            </ng-container>
          </td>
        </ng-container>
      </ng-container>
    </ng-container>

    <td *ngIf="showToolBar">
      <div class="toolbar" [ngClass]="listItem['editDisabled'] ? 'invisible' : ''">
        <ng-container *ngIf="innerWidth > mobileViewPortSize && listItem['toolbarIcons']">
          <ng-container *ngFor="let icon of listItem['toolbarIcons']['desktop'] | keyvalue: originalOrder; let iconIndex = index">
            <span class="icons d-flex justify-content-center align-items-center px-2 tooltip-icon"
                  (mouseenter)="checkTooltipHover(iconIndex, true)"
                  (mouseleave)="checkTooltipHover(iconIndex, false)"
                  (click)="onToolbarClick.emit({dataObject: listItem['dataObject'], operation: icon['value']['event']['operation']})"
                  [ngClass]="icon['value']['hidden'] === true ? 'disable-toolbar-icon' : ''"
                  [ngStyle]="{'outline': isRowHovered[i] && icon['value']['enableHoverEffect'] ? icon['value']['rowHoverBorder'] : 'none', 'background-color': isTooltipHovered[iconIndex] && isRowHovered[i] && icon['value']['enableHoverEffect'] ? icon['value']['iconHoverBackgroundColor'] : 'transparent'}">
              <beaconstac-tooltip
                *ngIf="icon['value']['event']['type'] !== 'dropdown'"
                elementClass="{{icon['value']['class']}} font-size-20px"
                content="{{icon['value']['tooltip']}}"
                tooltipPosition="top"
                caretPosition="left"
                class="desktop-tooltip"
                [color]="isTooltipHovered[iconIndex] && isRowHovered[i] && icon['value']['enableHoverEffect'] ? icon['value']['iconHoverColor'] : icon['value']['color']"
              ></beaconstac-tooltip>
              <span *ngIf="icon['value']['event']['type'] === 'tooltipWithLabel'" [ngStyle]="{'color': isTooltipHovered[iconIndex] && isRowHovered[i] && icon['value']['enableHoverEffect'] ? icon['value']['iconHoverColor'] : icon['value']['color']}" class="ml-2">{{icon['value']['event']['label']}}</span>
            </span>
            <span class="icons"
                  (click)="onToolbarClick.emit({dataObject: listItem['dataObject'], operation: icon['value']['event']['operation']})" [ngClass]="icon['value']['hidden'] === true ? 'disable-toolbar-icon' : ''"
                  *ngIf="icon['value']['event']['type'] && icon['value']['event']['type'] === 'text'" [ngStyle]="{'color': icon['value']['color']}" style="text-decoration: underline;">
                  {{icon['value']['event']['content']}}
            </span>
            <span class="secondary-on-hover" *ngIf="icon['value']['event']['type'] === 'dropdown'">
              <div class="dropdown">
                <button class="border-0 bg-transparent p-0 dropdownMenuButton" type="button" id="dropdownMenuButton{{i}}" (click)="toggleDropdown(i, listItem['dataObject'])" aria-haspopup="true" [attr.aria-expanded]="dropdownStates[i] ? 'true' : 'false'">
                  <i aria-hidden="true" class="fa-ellipsis-v fas fa-lg"></i>
                </button>

                <div class="dropdown-menu custom-dropdown-menu" [class.show]="dropdownStates[i]">
                  <a class="dropdown-item custom-dropdown-item"
                    *ngFor="let item of icon['value']['event']['content']"
                    [ngClass]="{'text-danger delete-item': (item['value'] | lowercase) === 'delete', 'text-dark normal-item': (item['value'] | lowercase) !== 'delete'}"
                    (click)="onToolbarDropdownChange.emit({dataObject: listItem['dataObject'], operation: {value:item['value']}}); toggleDropdown(i, listItem['dataObject'])">
                    <span [ngStyle]="{'opacity': item['isPremium'] && item['isPremium'] === true ? 0.5 : 1}" >{{ item['name'] }}</span>
                    <span *ngIf="item['isPremium'] && item['isPremium'] === true" class="ml-3"><i class="fas fa-crown" style="color: #fcbf49"></i></span>
                  </a>
                </div>
              </div>
            </span>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="innerWidth < mobileViewPortSize && listItem['toolbarIcons']">
          <ng-container *ngFor="let icon of listItem['toolbarIcons']['mobile'] | keyvalue: originalOrder;">
            <span class="icons" (click)="onToolbarClick.emit({dataObject: listItem['dataObject'], operation: icon['value']['event']['operation']})" [ngClass]="icon['value']['hidden'] === true ? 'disable-toolbar-icon' : ''">
              <beaconstac-tooltip
                *ngIf="icon['value']['tooltip']"
                elementClass="{{icon['value']['class']}} font-size-20px"
                content="{{icon['value']['tooltip']}}"
                tooltipPosition="top"
                caretPosition="left"
                style="margin-top: 0 !important;"
                [color]="icon['value']['color']"
              ></beaconstac-tooltip>
            </span>
            <div class="dropdown" *ngIf="icon['value']['event']['type'] === 'dropdown'">
              <button class="border-0 bg-transparent p-0 dropdownMenuButton" type="button" id="dropdownMenuButton{{i}}" (click)="toggleDropdown(i, listItem['dataObject'])" aria-haspopup="true" [attr.aria-expanded]="dropdownStates[i] ? 'true' : 'false'">
                <i aria-hidden="true" class="fa-ellipsis-v fas fa-lg"></i>
              </button>

              <div class="dropdown-menu custom-dropdown-menu" [class.show]="dropdownStates[i]">
                <a class="dropdown-item custom-dropdown-item"
                  *ngFor="let item of icon['value']['event']['content']"
                  [ngClass]="{'text-danger delete-item': (item['value'] | lowercase) === 'delete', 'text-dark normal-item': (item['value'] | lowercase) !== 'delete'}"
                  (click)="onMobileToolbarDropdownChange.emit({dataObject: listItem['dataObject'], operation: {value:item['value']}}); toggleDropdown(i, listItem['dataObject'])">
                  <span [ngStyle]="{'opacity': item['isPremium'] && item['isPremium'] === true ? 0.5 : 1}" >{{ item['name'] }}</span>
                  <span *ngIf="item['isPremium'] && item['isPremium'] === true" class="ml-3"><i class="fas fa-crown" style="color: #fcbf49"></i></span>
                </a>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </td>
  </tr>
  </tbody>
</table>
<div *ngIf="tableData.data.length < 1">
  <div *ngIf="showInbuiltEmptyState && (searchValue?.length > 0) && (emptyStateType === EMPTY_STATE_TYPES.DEFAULT)" class="table text-center" style="border-right: 1px solid #E4E5E7; border-left: 1px solid #E4E5E7;">
    <div style="padding-top: 48px">
      <img style="width: 216px; height: 216px" [src]="emptyStateUrl">
    </div>
    <div class="subtitle-1" style="margin-top: 32px">No results found for "{{searchValue}}"</div>
    <div class="subtitle-2" style="margin-top: 8px; margin-bottom: 48px">Please check spelling or try different keywords</div>
  </div>
  <div *ngIf="showInbuiltEmptyState && (emptyStateType === EMPTY_STATE_TYPES.ACTION_BUTTON_SUPPORT)" class="table text-center" style="border-right: 1px solid #E4E5E7; border-left: 1px solid #E4E5E7;">
    <div style="padding-top: 48px">
      <img style="width: 216px; height: 216px" [src]="emptyStateUrl">
    </div>
    <div class="subtitle-1" style="margin-top: 32px">{{emptyStateTitle}}</div>
    <div class="subtitle-2" style="margin-top: 8px; margin-bottom: 48px">{{emptyStateDescription}}</div>
    <div class="empty-button-container">
      <beaconstac-button
        [type]="BUTTON_TYPES.PRIMARY"
        [style]="BUTTON_STYLES.STROKE"
        [label]="'Reset Filters'"
        (click)="emptyStateButtonClick.emit()"
      ></beaconstac-button>
    </div>
  </div>
</div>
<div class="d-flex" *ngIf="showLoadMore || isTwoStepPagination || pagination > 0"
     [ngStyle]="{'padding': innerWidth > mobileViewPortSize ? '16px 32px' : '16px 8px'}"
     style="background: white; padding: 16px 32px; border: 1px solid #E4E5E7; border-top: 0; justify-content: space-between">
  <div class="w-50" *ngIf="!isTwoStepPagination && pagination && pagination > 0 && currentPage">
    <beaconstac-pagination [pageCount]="currentPage" [pageSize]="pageSize" [totalResults]=totalResults class="pagination" (onPageChange)="onPageChange.emit($event)"></beaconstac-pagination>
  </div>
  <div class="w-50" *ngIf="isTwoStepPagination" style="display: flex; flex-direction: row">
    <span class="page-link" [ngStyle]="{'disabled': twoStepPaginationFirstPage}" (click)="twoStepPaginationPrev.emit()"><i class="fas fa-angle-left"></i></span>
    <span class="page-link" [ngStyle]="{'disabled': twoStepPaginationLastPage}" (click)="twoStepPaginationNext.emit()"><i class="fas fa-angle-right"></i></span>
  </div>

  <div style="width: -webkit-fill-available;" *ngIf="showLoadMore">
    <div *ngIf="!fetchingData" class="d-flex align-items-center justify-content-center bstac-tint-blue p-3">
      <span class="cursor-pointer" (click)="loadMoreClicked.emit()"><i class="fas fa-arrow-down mr-1"></i> Load more</span>
    </div>
    <div class="d-flex justify-content-center align-items-center py-2" *ngIf="fetchingData">
      <spinner class="custom-spinner-analytics" [size]="30" [tickness]="2">
      </spinner>
    </div>
  </div>

  <div *ngIf="showPages && pages?.length > 0" style="width: 19%;"
       [ngStyle]="{'width': innerWidth > mobileViewPortSize ? '19%' : 'auto'}"
  >
    <beaconstac-filter-dropdown
      [title]="pages[0]['name']"
      [listItems]="pages"
      [disableInput]="true"
      *ngIf="showPages"
      [optionLabelField]="'name'"
      [optionValueField]="'value'"
      [width]="innerWidth > mobileViewPortSize ? 'auto' : '80px'"
      [value]="pages[currentPageSize]"
      (valueChange)="updatePagination($event); onShowPagesChange.emit($event)"
      [enableInfiniteScrolling]="enableInfiniteScrolling"
      (fetchMoreData)="fetchDataOnScroll($event)"
      [isFetchingData]="isFetchingData"
    ></beaconstac-filter-dropdown>
  </div>
</div>
